import { Button, CircularProgress, Container, Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import React from 'react';

const useStyles = makeStyles(theme => ({
  navigationButtonsPhone: {
    padding: theme.spacing(),
    background: 'white',
    paddingBottom: theme.spacing(4)
  },
  navigationButtonsDesktop: {
    paddingLeft: theme.spacing(4),
    paddingRight: theme.spacing(4)
  },
  buttons: {
    width: '100%'
  }
}));

export default function FinalButtonsMobile({
  activeStep,
  isPhone,
  loadingSendPre,
  handleBack,
  cancelText,
  okText,
  handleOk,
  isSubmitting
}) {
  const classes = useStyles();

  const getIcon = () => {
    if (isSubmitting || loadingSendPre) {
      return <CircularProgress color="inherit" size={20} />;
    }
    return null;
  };

  return (
    <Container
      maxWidth="lg"
      className={
        isPhone
          ? classes.navigationButtonsPhone
          : classes.navigationButtonsDesktop
      }
    >
      <Grid container alignItems="flex-end" justifyContent="center" spacing={1}>
        {okText && (
          <Grid item xs={12}>
            <Button
              type="submit"
              color="primary"
              className={classes.buttons}
              disabled={isSubmitting || loadingSendPre}
              variant="contained"
              startIcon={getIcon()}
              onClick={() => {
                if (handleOk) {
                  handleOk();
                }
              }}
            >
              {okText}
            </Button>
          </Grid>
        )}
        <Grid item xs={12}>
          <Button
            onClick={handleBack}
            className={classes.buttons}
            // size={isPhone ? 'small' : 'medium'}
            variant="outlined"
            disabled={activeStep === 0}
            // startIcon={<NavigateBeforeIcon />}
          >
            {cancelText}
          </Button>
        </Grid>
      </Grid>
    </Container>
  );
}
